import SSOPaymentWithdrawal from './SSOPaymentWithdrawal';

export default SSOPaymentWithdrawal;
